import React from "react"
import { UncontrolledTooltip, Card } from "reactstrap"

import DatetimeRenderer from "../../Material/DatetimeRenderer"
import UpdateIncidentDocumentInfo from "../Components/UpdateIncidentDocumentInfo"
import toTitleCase from "../../Functions/toTitleCase"
import { cleanDocumentUrl } from "../../Material/DocumentModal/DocumentsListNew"
import { isImage, isPdf, isVideo } from "../../Material/DocumentModal/utils"
import withApolloClient from "../../withApolloClient"
import "./DocumentsTab.css"

class DocumentDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    render() {
        const { document, refetchQuery, isLoading, ownerLabel } = this.props
        const docKey = document?.pk || "incident-doc"
        const docTypeLabel = document.documentType ? toTitleCase(document.documentType.typeName) : "--"
        const ownerInfo = typeof ownerLabel === "object" && ownerLabel !== null ? ownerLabel : { kind: null, label: ownerLabel || "" }
        const ownerBadgeVariant = ownerInfo.kind === "party" ? "owner-badge-party" : ownerInfo.kind === "liability" ? "owner-badge-liability" : ownerInfo.kind === "subrogation" ? "owner-badge-subrogation" : "owner-badge-default"
        const ownerTypeLabel = ownerInfo.kind ? toTitleCase(ownerInfo.kind) : ""
        const ownerChipLabel = ownerInfo.label || ""
        const notesPreview = document.notes
            ? document.notes.split(" ").length > 6
                ? document.notes.split(" ").slice(0, 6).join(" ") + "..."
                : document.notes
            : "---"
        return (
            <Card className="DocumentCard incident-doc-card" key={docKey}>
                <div className="DocumentCardHeader incident-doc-header">
                    <p className="incident-doc-title mb-0">
                        <i className={document.document && document.document.toUpperCase().slice(-4) === ".PDF" ? "fa fa-file-pdf-o" : "fa fa-picture-o"} aria-hidden="true" />&nbsp;{docTypeLabel}
                    </p>
                    <div className="incident-doc-actions">
                        {this.props.showSelectCheckbox !== false && (
                            <input
                                type="checkbox"
                                className="doc-select-checkbox"
                                checked={this.props.isSelected}
                                disabled={isLoading}
                                onChange={() => this.props.toggleSelectDoc(document)}
                            />
                        )}
                        <i className="fa fa-arrows-alt" onClick={() => !isLoading && this.props.viewDocuments()} title="Preview Document" />
                    </div>
                </div>
                <div className="DocumentCardPreview">
                    {document ? (
                        isVideo(document.url, document.document) ?
                            <video className="DocumentCardPreviewEmbed DocViewerVideo" src={document.url} controls style={{ maxWidth: '100%', maxHeight: 180 }} /> :
                            isImage(cleanDocumentUrl(document.url), document.document) ?
                                <img className="DocumentCardPreviewEmbed DocViewerImage" src={document.url} alt="Document" /> :
                                isPdf(cleanDocumentUrl(document.url), document.document) ?
                                    <iframe scrolling="no" className="DocumentCardPreviewEmbed" src={cleanDocumentUrl(document.url)} title={`document-iframe-${docKey}`} /> :
                                    <div className="DocumentCardPreviewEmbed d-flex align-items-center justify-content-center">
                                        <div className="text-center px-2">
                                            <i className="fa fa-file-text-o fa-2x mb-2" aria-hidden="true" />
                                            <div>Preview isn’t available here. Click expand icon to view or download the document.</div>
                                        </div>
                                    </div>
                    ) : ''}
                </div>
                <div className="incident-doc-footer">
                    <div className="incident-meta-line mb-2">
                        <i className="fa fa-clock-o" aria-hidden="true" />
                        <span className="incident-doc-text">
                            Uploaded <b style={{ color: "#374151" }}>{document.dateAdded ? <DatetimeRenderer datetime={document.dateAdded} /> : "--"}</b>
                            {" "}by <b style={{ color: "#374151" }}>{document.createdBy?.username || "--"}</b>
                        </span>
                    </div>
                    {!!ownerLabel && (
                        <div className="owner-badge-row mb-2">
                            {ownerInfo.kind ? (
                                <>
                                    <span className={`owner-badge ${ownerBadgeVariant}`}>
                                        <i className="fa fa-link owner-badge-icon" aria-hidden="true" />
                                        {ownerTypeLabel}
                                    </span>
                                    <span className={`owner-badge ${ownerInfo.kind === "party" ? "owner-badge-party-name" : "owner-badge-claim-id"}`}>
                                        {ownerChipLabel}
                                    </span>
                                </>
                            ) : (
                                <span className={`owner-badge ${ownerBadgeVariant}`}>
                                    <i className="fa fa-link owner-badge-icon" aria-hidden="true" />
                                    {ownerChipLabel}
                                </span>
                            )}
                        </div>
                    )}
                    <div className="incident-notes-row">
                        <span className="incident-doc-text" id={`docNotesTooltip_${docKey}`}>
                            <b style={{ color: "#374151" }}>Notes</b>: {notesPreview}
                        </span>
                        {!!document.notes && (
                            <UncontrolledTooltip placement="top" target={`docNotesTooltip_${docKey}`}>
                                {document.notes}
                            </UncontrolledTooltip>
                        )}
                        {this.props.showEditChip !== false && (
                            <>
                                <span className="doc-action-chip" id={`edit_document_notes_${docKey}`} onClick={() => !isLoading && this.setState({ openModal: `edit_document_notes_${docKey}` })}>
                                    <i className="fa fa-pencil-square-o" aria-hidden="true" />
                                </span>
                                {this.state.openModal === `edit_document_notes_${docKey}` && (
                                    <UpdateIncidentDocumentInfo
                                        open={true}
                                        target={`edit_document_notes_${docKey}`}
                                        handleClose={() => this.setState({ openModal: "" })}
                                        name={"notes"}
                                        value={document.notes || ""}
                                        title={"Edit Document Notes"}
                                        type="textarea"
                                        docId={document.id}
                                        refetch={refetchQuery}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Card >
        )
    }
}

export default withApolloClient(DocumentDetails)
